<script setup>
import { BRAND_LOGO_URL, MAC_APP_DOWNLOAD_URL } from "@/shared/config/constants";

const steps = [
  { num: "01", title: "安装小能熊 mac app", body: "下载 DMG，拖入 Applications 后打开小能熊 agent 经济学。", code: MAC_APP_DOWNLOAD_URL.replace("https://", "") },
  { num: "02", title: "在 app 内连接账号", body: "菜单栏或 Settings 里点击连接，App 会打开一个带设备码的网页。", code: "/tokenomics/native/approve?code=..." },
  { num: "03", title: "网页批准设备", body: "微信登录后批准这台 Mac。Token 明文只返回给 App 一次，不在网页重复展示。", code: null },
  { num: "04", title: "app 保存到 keychain", body: "App 兑换 upload token 并只写入 Keychain；UserDefaults 只保存同步状态。", code: null },
  { num: "05", title: "跟随刷新自动同步", body: "每次本机刷新后上传今天的 Codex 与 Claude Code daily summary。", code: "POST /tokenomics/api/uploads" },
];
</script>

<template>
  <section class="guide-card">
    <div class="guide-head">
      <div>
        <h2>mac app 自动上传流程</h2>
        <p>默认不再需要 npm 上传器或 codex automation。mac app 会打开网页授权，保存上传 token 到 keychain。</p>
      </div>
      <span class="guide-chip">
        <img :src="BRAND_LOGO_URL" alt="" />
      </span>
    </div>
    <ol class="guide-steps">
      <li v-for="step in steps" :key="step.num" class="guide-step">
        <span class="step-num">{{ step.num }}</span>
        <strong>{{ step.title }}</strong>
        <span>{{ step.body }}</span>
        <code v-if="step.code">{{ step.code }}</code>
      </li>
    </ol>
    <p class="guide-privacy">
      mac app 只发送 codexbar 日汇总字段，不上传 codex 或 claude code 原始 jsonl、prompt、assistant message、tool
      output、cwd、thread/path/source 信息。
    </p>
  </section>
</template>
